import { create } from 'zustand'
import { fetchUpdates } from '../api/update'
import { Update } from '../helpers/types/update'

export interface UpdateState {
	fetchUpdates: (id: number) => Promise<Update[]>
}

export const updateStore = create<UpdateState>(() => ({
	fetchUpdates: async (id) => {
		const data = await fetchUpdates(id)
		return data
	}
}))
